// src/pages/PostDetail/index.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Layout, Typography, Spin, Alert, Tag, Divider, Avatar, Space, BackTop } from 'antd';
import { CalendarOutlined, PushpinOutlined, UserOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import moment from 'moment';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer'; 
import './index.css';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const PostDetail = ({ posts, loggedInUser, onLogout }) => { 
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        setLoading(true);
        setError(null);
        const foundPost = posts.find(p => p.id === id);

        if (foundPost) {
            setPost(foundPost);
            setLoading(false);
        } else {
            setError('文章未找到。');
            setLoading(false);
        }
    }, [id, posts]);

    if (loading) {
        return (
            <Layout className="blog-layout">
                <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
                <Content className="post-detail-content">
                    <div className="loading-container">
                        <Spin size="large" tip="加载文章中..." />
                    </div>
                </Content>
                <AppFooter />
            </Layout>
        );
    }

    if (error) {
        return (
            <Layout className="blog-layout">
                <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
                <Content className="post-detail-content">
                    <div className="error-container">
                        <Alert message="错误" description={error} type="error" showIcon />
                    </div>
                </Content>
                <AppFooter />
            </Layout>
        );
    }

    if (!post) {
        return (
            <Layout className="blog-layout">
                <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
                <Content className="post-detail-content">
                    <div className="error-container">
                       <Alert message="提示" description="没有找到这篇文章。" type="info" showIcon />
                    </div>
                </Content>
                <AppFooter />
            </Layout>
        );
    }

    const displayAuthorAvatar =
        loggedInUser && loggedInUser.username === post.author
            ? loggedInUser.aboutInfo?.avatar
            : 'https://gw.alipayobjects.com/zos/rmsportal/NoOzTz_ZCwJbWCrKzJ.png'; 

    return (
        <Layout className="blog-layout">
            <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
            <Content className="post-detail-content">
                <div className="post-detail-container">
                    <Title level={1} className="post-detail-title">{post.title}</Title>
                    <Space size="large" className="post-meta">
                        <Text><UserOutlined /> 作者：<Avatar size="small" src={displayAuthorAvatar} /> {post.author}</Text>
                        <Text><CalendarOutlined /> 日期：{moment(post.date).format('YYYY年M月D日 HH:mm')}</Text>
                        <Text><PushpinOutlined /> 标签：{post.tags.map(tag => <Tag key={tag} color="blue">{tag}</Tag>)}</Text>
                    </Space>
                    <Divider />
                    <Paragraph className="markdown-body">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {post.content}
                        </ReactMarkdown>
                    </Paragraph>
                </div>
                <BackTop />
            </Content>
            <AppFooter />
        </Layout>
    );
};

export default PostDetail;
